import { useEffect, useState } from 'react';
import { api } from '../lib/api';

interface Source {
  id: string;
  name: string;
  status: string;
  url?: string;
  note?: string;
}

interface StatusResponse {
  checked_at_iso: string;
  sources: Source[];
}

export default function AboutData() {
  const [data, setData] = useState<StatusResponse | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .sourcesStatus()
      .then((d) => setData(d as StatusResponse))
      .catch((e) => setErr(String(e)));
  }, []);

  return (
    <div className="page">
      <h1>Sources de données</h1>
      <p>
        Toutes les positions confirmées affichées dans le planétarium proviennent
        de <strong>JPL Horizons</strong> (vecteurs d'état). Les éléments orbitaux
        des petits corps proviennent de <strong>JPL SBDB</strong> et MPCORB.
        Les couches d'observation prévues (v2) s'appuient sur les brokers Rubin,
        SNAPS et IRSA.
      </p>

      <h2>Inventaire des sources</h2>
      {err && <div className="banner">Erreur : {err}</div>}
      {!data && !err && <p>Chargement…</p>}
      {data && (
        <div className="card">
          <p style={{ marginTop: 0, color: 'var(--text-dim)' }}>
            Vérifié à {data.checked_at_iso}
          </p>
          <ul>
            {data.sources.map((s) => (
              <li key={s.id}>
                <strong>{s.name}</strong> — <em>{s.status}</em>
                {s.url && (
                  <>
                    {' '}— <a href={s.url} target="_blank" rel="noreferrer">
                      doc
                    </a>
                  </>
                )}
                {s.note && <> · {s.note}</>}
              </li>
            ))}
          </ul>
        </div>
      )}

      <h2>Limites</h2>
      <ul>
        <li>Pas de "temps réel brut" arbitraire : les vecteurs Horizons sont mis en cache.</li>
        <li>Les orbites Kepleriennes côté front sont des fallback visuels.</li>
        <li>Planet Nine = ensemble probabiliste, pas une position.</li>
        <li>Les alertes télescopes seront ingérées via brokers (v2), pas par scraping.</li>
      </ul>
    </div>
  );
}
